import { render, staticRenderFns } from "./privateLetter.vue?vue&type=template&id=284e8d2a&"
import script from "./privateLetter.vue?vue&type=script&lang=js&"
export * from "./privateLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports